import { Pipe, PipeTransform } from '@angular/core';
import { PublicWifiAccount } from '../store/reducers/public-wifi.reducer';

@Pipe({
  name: 'publicWifiAccountFilter',
})
export class PublicWifiAccountFilterPipe implements PipeTransform {
  transform(values: Array<PublicWifiAccount>, active: boolean): any {
    return (values || []).filter((v) =>
      active ? v.login !== v.technicalLoginId : v.login === v.technicalLoginId,
    );
  }
}
